import React from 'react';
import pankaj from '../../images/owners/pankaj.JPEG';
import shivam from '../../images/owners/shivam.JPEG';

function Professional() {
  // Detect if the screen width is small (mobile)
  const isMobile = window.innerWidth <= 768;

  return (
    <div className="container-fluid py-5">
      {/* First row */}
      <div className="container">
        <div className="row mb-5">
          {/* Image Section */}
          <div className="col-12 col-md-6 mb-3 mb-md-0">
            <img 
              src={shivam} 
              alt="Professional Image 1" 
              className="w-100" 
              style={{ 
                height: isMobile ? '50vh' : '80vh', 
                objectFit: '100% 100%' 
              }} 
            />
          </div>
          {/* Text Section */}
          <div className="col-12 col-md-6 d-flex align-items-center justify-content-center">
            <div className="text-center">
              <h2>Shivam Rathore</h2>
              <p>Shivam Rathore is the founder of SwingTraderrs, a dynamic company specializing in trading and tech management. With a deep understanding of the financial markets and cutting-edge technology, Shivam has built a business that seamlessly integrates trading strategies with tech-driven solutions. His leadership focuses on empowering clients with intuitive, data-driven tools to optimize trading decisions and enhance tech management efficiency. Under his guidance, SwingTraderrs has grown into a trusted name in the industry, offering innovative services that cater to both novice traders and seasoned professionals. Shivam's vision is to redefine the future of trading and tech management through continuous innovation.</p>
            </div>
          </div>
        </div>

        {/* Second row */}
        <div className="row">
          {/* Text Section */}
          <div className="col-12 col-md-6 d-flex align-items-center justify-content-between mb-3 mb-md-0">
            <div className="text-center">
              <h2>Pankaj Shah</h2>
              <p>Pankaj Shah is the co-founder of SwingTraderrs, a leading firm specializing in trading and technical solutions. With a strong foundation in both financial markets and advanced technology, Pankaj plays a pivotal role in shaping the company’s strategy and operations. His expertise lies in leveraging technical analysis and trading strategies to empower clients with accurate market insights and optimal solutions. Pankaj’s focus on innovation and efficiency has been instrumental in SwingTraderrs’ success, establishing the company as a trusted partner for individuals and businesses seeking to navigate the complex world of trading and technology. His leadership is driven by a passion for transforming the trading landscape.</p>
            </div>
          </div>

          {/* Image Section */}
          <div className="col-12 col-md-6 mb-3 mb-md-0">
            <img 
              src={pankaj} 
              alt="Professional Image 2" 
              className="w-100" 
              style={{ 
                height: isMobile ? '50vh' : '80vh', 
                objectFit: '100% 100%' 
              }} 
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Professional;
